import React from "react";

// Types
import type { queuesTab } from "src/types";

// Components
import IcomSwitchBtn from "src/components/icom-switch-btn";
import type { AVAILABLE_QUEUES } from "src/types/config-tabs";
import { useAppSelector } from "src/store/hooks";

interface QueueProps {
  currentConfig: queuesTab;
  setConfig: (config: any) => void;
  changeRegister: () => void;
}

const Queues: React.FC<QueueProps> = ({ currentConfig, setConfig, changeRegister }) => {
  const { userInfo } = useAppSelector((state) => state.auth);

  const handleQueue = (value: AVAILABLE_QUEUES) => {
    const normalizedValue = value.toLocaleLowerCase();

    if (normalizedValue.indexOf("abr") > -1 && !userInfo.hasMorgaCertificate && currentConfig.indexOf(value) === -1) return;

    changeRegister();

    const index = currentConfig.indexOf(value);

    const queuesCopy = [...currentConfig];

    if (index > -1) queuesCopy.splice(index, 1);
    else queuesCopy.push(value);

    setConfig(queuesCopy);
  };

  return (
    <>
      <div className="flex">
        <div className="w-1/4">
          <div className="form-group flex flex-col gap-3 mb-10">
            <span className="text-sm font-bold text-neutral-gray-800 dark:text-neutral-gray-50">ABR</span>

            <IcomSwitchBtn type="button" handleValue={() => handleQueue("abr")} currentValue={currentConfig.includes("abr")} />
          </div>

          <div className="form-group flex flex-col gap-3 mb-10">
            <span className="text-sm font-bold text-neutral-gray-800 dark:text-neutral-gray-50">ABR-texto</span>
            <IcomSwitchBtn type="button" handleValue={() => handleQueue("ABR-texto")} currentValue={currentConfig.includes("ABR-texto")} />
          </div>

          <div className="form-group flex flex-col gap-3 mb-10">
            <span className="text-sm font-bold text-neutral-gray-800 dark:text-neutral-gray-50">ABR-agendamento</span>
            <IcomSwitchBtn type="button" handleValue={() => handleQueue("ABR-agendamento")} currentValue={currentConfig.includes("ABR-agendamento")} />
          </div>

          <div className="form-group flex flex-col gap-3 mb-10">
            <span className="text-sm font-bold text-neutral-gray-800 dark:text-neutral-gray-50">ICOM</span>
            <IcomSwitchBtn type="button" handleValue={() => handleQueue("icom")} currentValue={currentConfig.includes("icom")} />
          </div>
        </div>
        <div className="w-1/4">
          <div className="form-group flex flex-col gap-3 mb-10">
            <span className="text-sm font-bold text-neutral-gray-800 dark:text-neutral-gray-50">TTS</span>
            <IcomSwitchBtn type="button" handleValue={() => handleQueue("tts")} currentValue={currentConfig.includes("tts")} />
          </div>

          <div className="form-group flex flex-col gap-3 mb-10">
            <span className="text-sm font-bold text-neutral-gray-800 dark:text-neutral-gray-50">ICOM Surdos</span>
            <IcomSwitchBtn type="button" handleValue={() => handleQueue("ICOM-surdos")} currentValue={currentConfig.includes("ICOM-surdos")} />
          </div>

          <div className="form-group flex flex-col gap-3 mb-10">
            <span className="text-sm font-bold text-neutral-gray-800 dark:text-neutral-gray-50">ICOM Prospects</span>
            <IcomSwitchBtn type="button" handleValue={() => handleQueue("ICOM-prospects")} currentValue={currentConfig.includes("ICOM-prospects")} />
          </div>

          <div className="form-group flex flex-col gap-3 mb-10">
            <span className="text-sm font-bold text-neutral-gray-800 dark:text-neutral-gray-50">Oculta</span>
            <IcomSwitchBtn type="button" handleValue={() => handleQueue("oculta")} currentValue={currentConfig.includes("oculta")} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Queues;
